<template>
  <div class="room">
      <blue-print :bridgeId="bridgeId"></blue-print>
  </div>
</template>
<script>
import BluePrint from '../../components/BluePrint'

export default {
  name: 'bridgeImg',
  components: { BluePrint },
  data() {
    return {
        bridgeId: '7553a665-0928-4416-9389-98e7cda26f0c'
    }
  },
}
</script>